import {
    CircleAlertIcon,
    CircleCheckIcon,
    CircleQuestionMarkIcon,
    CircleXIcon,
    InfoIcon,
    type LucideIcon,
} from 'lucide-react';

import { colorSystem } from '../../colorSystem';
import {
    CircleAlertFilledIcon,
    CircleCheckFilledIcon,
    CircleQuestionMarkFilledIcon,
    CircleXFilledIcon,
    InfoFilledIcon,
} from '../icons/filledIcons';

/** icons.md says what each status means and when to use it. */
export type StatusIconStatus = 'success' | 'warning' | 'error' | 'info' | 'pending';

/** `filled` cuts the glyph out of a solid shape, for emphasis, never for another meaning. */
export type StatusIconVariant = 'outline' | 'filled';

export type StatusIconVisual = Readonly<Record<StatusIconVariant, LucideIcon> & { color: string }>;

/**
 * Whatever draws a status takes its glyph from here; it may paint it in another color for its background.
 * Each status is a glyph in a circle, as before the switch to Lucide: warning is "!" in a circle, error X in a circle.
 */
export const STATUS_ICONS: Readonly<Record<StatusIconStatus, StatusIconVisual>> = {
    success: { outline: CircleCheckIcon, filled: CircleCheckFilledIcon, color: colorSystem.green[6] },
    warning: { outline: CircleAlertIcon, filled: CircleAlertFilledIcon, color: colorSystem.yellow[6] },
    error: { outline: CircleXIcon, filled: CircleXFilledIcon, color: colorSystem.red[6] },
    // The blue of the design system's info messages.
    info: { outline: InfoIcon, filled: InfoFilledIcon, color: colorSystem.blue[6] },
    // The grey of the design system's pending approval icon.
    pending: { outline: CircleQuestionMarkIcon, filled: CircleQuestionMarkFilledIcon, color: colorSystem.neutral[5] },
};
